/* Nancy Bakes — storefront JS (v2)
   ============================================================
   Handles: cart drawer + AJAX add-to-cart + cart-page reflow,
   qty steppers, predictive search overlay, cart badge updates.
   The PDP sticky bar is always-visible; no scroll observer needed.
*/
(function () {
  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ---------- Body classes ---------- */
  if ($("#nbPdpSticky")) document.body.classList.add("has-pdp-bar");

  /* ---------- Hide sticky bars when footer scrolls into view ---------- */
  const _footerEl = $(".nb-footer");
  const _bars = $$(".pdp-sticky, .cart-checkout-bar, .cyob-sticky");

  if (_footerEl && _bars.length) {
    const io = new IntersectionObserver(([entry]) => {
      _bars.forEach(bar => {
        bar.classList.toggle("is-near-footer", entry.isIntersecting);
      });
    }, {
      threshold: 0,
      rootMargin: "0px 0px -40px 0px"
    });

    io.observe(_footerEl);
  }

  /* ---------- Cart drawer ---------- */
  const drawer  = $("#nbCartDrawer");
  const overlay = $("#nbCartOverlay");

  const openCart = () => {
    drawer?.classList.add("is-open");
    overlay?.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };

  const closeCart = () => {
    drawer?.classList.remove("is-open");
    overlay?.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  $$("[data-cart-open]").forEach(el => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      refreshCart().then(openCart);
    });
  });

  $$("[data-cart-close]").forEach(el => {
    el.addEventListener("click", closeCart);
  });

  overlay?.addEventListener("click", closeCart);

  /* ---------- Menu drawer (slides from left) ---------- */
  const menuDrawer  = $("#nbMenuDrawer");
  const menuOverlay = $("#nbMenuOverlay");

  const openMenu = () => {
    menuDrawer?.classList.add("is-open");
    menuOverlay?.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };

  const closeMenu = () => {
    menuDrawer?.classList.remove("is-open");
    menuOverlay?.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  $$("[data-menu-open]").forEach(el => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      openMenu();
    });
  });

  $$("[data-menu-close]").forEach(el => {
    el.addEventListener("click", closeMenu);
  });

  menuOverlay?.addEventListener("click", closeMenu);

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
      closeSearch();
      closeMenu();
    }
  });

  /* ---------- Toast notifications ---------- */
  function showToast(msg) {
    let toast = $("#nbToast");

    if (!toast) {
      toast = document.createElement("div");
      toast.id = "nbToast";
      toast.className = "nb-toast";
      document.body.appendChild(toast);
    }

    toast.textContent = msg;
    toast.classList.add("is-visible");

    clearTimeout(toast._t);

    toast._t = setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 1800);
  }

  /* ============================================================
     CART NOTIFICATION POPUP
     Uses the NEW VitaMeals popup IDs:
     #vm-cart-notif
     #vm-cart-notif-image
     #vm-cart-notif-title
     #vm-cart-notif-price
     #vm-cart-notif-count
     ============================================================ */

  function showCartNotif(item, sourceForm = null, cart = null) {
    const notif = $("#vm-cart-notif");

    if (!notif) return;

    const titleEl = $("#vm-cart-notif-title");
    const priceEl = $("#vm-cart-notif-price");
    const imgEl   = $("#vm-cart-notif-image");
    const countEl = $("#vm-cart-notif-count");

    /* ---------- Find the real cart line ---------- */
    let cartItem = null;

    if (cart && item?.id) {
      cartItem = cart.items?.find(line => {
        return String(line.variant_id) === String(item.id);
      });
    }

    /* ---------- Product title ---------- */
    const card =
      sourceForm?.closest(
        ".pc, .spotlight, .product-card, .card-wrapper, .card"
      );

    const domTitle =
      card?.querySelector(
        ".pc__title, .spotlight__title, .card__heading, h3, h2"
      )?.textContent?.trim();

    const title =
      cartItem?.product_title ||
      item?.product_title ||
      item?.title ||
      domTitle ||
      "Product";

    /* ---------- Product price ---------- */
    const price =
      cartItem?.final_price ??
      item?.final_price ??
      item?.price ??
      0;

    const qty =
      cartItem?.quantity ||
      item?.quantity ||
      1;

    /* ---------- Product image ---------- */
    let image =
      cartItem?.image ||
      cartItem?.featured_image?.url ||
      item?.image ||
      item?.featured_image?.url ||
      "";

    /* ---------- Fallback to product card image ---------- */
    if (!image && card) {
      const img = card.querySelector("img");

      if (img) {
        image =
          img.currentSrc ||
          img.src ||
          img.getAttribute("src") ||
          "";
      }
    }

    /* ---------- Fallback to form's parent image ---------- */
    if (!image && sourceForm) {
      const img = sourceForm.parentElement?.querySelector("img");

      if (img) {
        image =
          img.currentSrc ||
          img.src ||
          img.getAttribute("src") ||
          "";
      }
    }

    /* ---------- Normalize image URL ---------- */
    if (image && image.startsWith("//")) {
      image = "https:" + image;
    }

    /* ---------- Fill product title ---------- */
    if (titleEl) {
      titleEl.textContent = title;
    }

    /* ---------- Fill price + quantity ---------- */
    if (priceEl) {
      const priceText = (Number(price) / 100).toLocaleString("en-EG", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });

      priceEl.textContent = `LE ${priceText} · qty ${qty}`;
    }

    /* ---------- Fill image ---------- */
    if (imgEl) {
      if (image) {
        imgEl.src = image;
        imgEl.alt = title;
        imgEl.style.display = "";
      } else {
        imgEl.removeAttribute("src");
        imgEl.alt = title;
        imgEl.style.display = "none";
      }
    }

    /* ---------- Fill cart count ---------- */
    if (countEl) {
      countEl.textContent = cart?.item_count ?? 0;
    }

    /* ---------- Open popup ---------- */
    notif.classList.add("is-visible");
    notif.setAttribute("aria-hidden", "false");

    clearTimeout(notif._t);

    notif._t = setTimeout(() => {
      notif.classList.remove("is-visible");
      notif.setAttribute("aria-hidden", "true");
    }, 6000);
  }

  /* ---------- Close popup ---------- */

  $$(".vm-cart-notif__close").forEach(el => {
    el.addEventListener("click", () => {
      const notif = $("#vm-cart-notif");

      if (!notif) return;

      notif.classList.remove("is-visible");
      notif.setAttribute("aria-hidden", "true");
    });
  });

  $$(".vm-cart-notif__keep").forEach(el => {
    el.addEventListener("click", () => {
      const notif = $("#vm-cart-notif");

      if (!notif) return;

      notif.classList.remove("is-visible");
      notif.setAttribute("aria-hidden", "true");
    });
  });

  /* ---------- Close popup when clicking outside ---------- */

  document.addEventListener("click", (e) => {
    const notif = $("#vm-cart-notif");

    if (!notif || !notif.classList.contains("is-visible")) return;

    if (
      !e.target.closest("#vm-cart-notif") &&
      !e.target.closest(
        "form[data-add-to-cart], form.pc__add-form"
      )
    ) {
      notif.classList.remove("is-visible");
      notif.setAttribute("aria-hidden", "true");
    }
  });

  /* True when this preview is running inside Shopify's theme editor iframe.
     In that mode the cart drawer is unreliable (the editor scopes cart cookies
     differently), so we show a toast instead of opening the drawer. */
  const isEditor = !!(
    window.Shopify &&
    window.Shopify.designMode
  );

  /* ============================================================
     ADD TO CART
     Handles BOTH:

     form[data-add-to-cart]

     AND

     form.pc__add-form
     ============================================================ */

  document.addEventListener("submit", async (e) => {

    const form = e.target.closest(
      "form[data-add-to-cart], form.pc__add-form"
    );

    if (!form) return;

    e.preventDefault();

    const data = new FormData(form);

    const btn = form.querySelector("[type=submit]");

    /* Visual feedback only */
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = "0.55";
      btn.style.transform = "scale(0.92)";
    }

    try {

      /* ---------- Add product ---------- */

      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: data,
        headers: {
          "Accept": "application/json"
        }
      });

      if (!res.ok) {
        throw new Error(await res.text());
      }

      const added = await res.json();

      /* ---------- Get updated cart ---------- */

      const cartRes = await fetch("/cart.js", {
        headers: {
          "Accept": "application/json"
        }
      });

      if (!cartRes.ok) {
        throw new Error("Could not load cart");
      }

      const cart = await cartRes.json();

      /* ---------- Update cart drawer + badge ---------- */

      await refreshCart();

      /* ---------- Dedicated cart page ---------- */

      if (
        document.body.classList.contains("template-cart")
      ) {

        window.location.reload();

      } else {

        /* ---------- Show popup ---------- */

        showCartNotif(
          added,
          form,
          cart
        );
      }

    } catch (err) {

      console.error("VitaMeals add to cart error:", err);

      showToast("Couldn't add — please try again");

    } finally {

      if (btn) {

        setTimeout(() => {

          btn.disabled = false;
          btn.style.opacity = "";
          btn.style.transform = "";

        }, 250);

      }

    }

  });

  /* ---------- Qty steppers (PDP main + drawer + cart page) ---------- */

  document.addEventListener("click", (e) => {

    const dec = e.target.closest("[data-qty-dec]");
    const inc = e.target.closest("[data-qty-inc]");

    if (!dec && !inc) return;

    const wrap = (dec || inc).closest("[data-qty]");

    const input =
      wrap?.querySelector("input[name=quantity]");

    const out =
      wrap?.querySelector("[data-qty-out]");

    if (!input) return;

    let n = parseInt(input.value || "1", 10);

    n = inc
      ? n + 1
      : Math.max(1, n - 1);

    input.value = n;

    if (out) {
      out.textContent = n;
    }

  });

  /* ---------- Cart-line controls (drawer + cart page) ---------- */

  document.addEventListener("click", async (e) => {

    const inc = e.target.closest("[data-line-inc]");
    const dec = e.target.closest("[data-line-dec]");
    const rm  = e.target.closest("[data-line-remove]");

    if (!inc && !dec && !rm) return;

    const row = e.target.closest(".cart-line");

    if (!row) return;

    const key = row.dataset.key;

    const qtyEl =
      row.querySelector("[data-line-qty]");

    let q = parseInt(
      qtyEl?.textContent || "1",
      10
    );

    if (rm) {
      q = 0;
    } else if (inc) {
      q += 1;
    } else {
      q = Math.max(0, q - 1);
    }

    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity: q
      }),
    });

    if (
      document.body.classList.contains("template-cart")
    ) {

      window.location.reload();

    } else {

      refreshCart();

    }

  });

  /* ---------- Bundle remove ---------- */

  document.addEventListener("click", async (e) => {

    const btn =
      e.target.closest("[data-bundle-remove]");

    if (!btn) return;

    const boxId =
      btn.dataset.bundleRemove;

    btn.disabled = true;

    try {

      const cartRes = await fetch("/cart.js", {
        headers: {
          "Accept": "application/json"
        }
      });

      const cart = await cartRes.json();

      const updates = {};

      cart.items.forEach(it => {

        if (
          it.properties?._box_id === boxId
        ) {
          updates[it.key] = 0;
        }

      });

      if (
        Object.keys(updates).length === 0
      ) {
        return;
      }

      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          updates
        }),
      });

      if (
        document.body.classList.contains("template-cart")
      ) {

        window.location.reload();

      } else {

        refreshCart();

      }

    } catch (err) {

      console.error(err);

      btn.disabled = false;

    }

  });

  /* ---------- Bundle qty stepper ---------- */

  document.addEventListener("click", async (e) => {

    const inc =
      e.target.closest("[data-bundle-inc]");

    const dec =
      e.target.closest("[data-bundle-dec]");

    if (!inc && !dec) return;

    const wrap =
      (inc || dec).closest("[data-bundle-qty]");

    const bundleEl =
      (inc || dec).closest(".cart-bundle");

    if (!wrap || !bundleEl) return;

    const boxId =
      wrap.dataset.bundleQty;

    const curCnt =
      parseInt(
        bundleEl.dataset.bundleCount || "1",
        10
      );

    const newCnt =
      inc
        ? curCnt + 1
        : curCnt - 1;

    if (
      newCnt < 0 ||
      newCnt > 20
    ) {
      return;
    }

    [inc, dec]
      .filter(Boolean)
      .forEach(b => {
        b.disabled = true;
      });

    try {

      const cart =
        await (
          await fetch("/cart.js")
        ).json();

      const lines =
        cart.items.filter(
          it =>
            it.properties?._box_id === boxId
        );

      if (lines.length === 0) {
        return;
      }

      const updates = {};

      if (newCnt === 0) {

        lines.forEach(it => {
          updates[it.key] = 0;
        });

      } else {

        lines.forEach(it => {

          updates[it.key] =
            Math.max(
              0,
              Math.round(
                it.quantity *
                newCnt /
                curCnt
              )
            );

        });

      }

      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          updates
        }),
      });

      if (
        document.body.classList.contains("template-cart")
      ) {

        window.location.reload();

      } else {

        refreshCart();

      }

    } catch (err) {

      console.error(err);

      [inc, dec]
        .filter(Boolean)
        .forEach(b => {
          b.disabled = false;
        });

    }

  });

  /* ============================================================
     CART DRAWER RENDERING
     ============================================================ */

  async function refreshCart() {

    const res = await fetch("/cart.js", {
      headers: {
        "Accept": "application/json"
      }
    });

    const cart = await res.json();

    const list    = $("#nbCartList");
    const foot    = $("#nbCartFoot");
    const empty   = $("#nbCartEmpty");
    const totalEl = $("#nbCartTotal");

    /* ---------- Cart badges ---------- */

    const badgeEls =
      $$("[data-cart-count]");

    badgeEls.forEach(b => {

      b.textContent =
        cart.item_count > 0
          ? cart.item_count
          : "";

      b.style.display =
        cart.item_count > 0
          ? ""
          : "none";

    });

    /* ---------- Popup cart count ---------- */

    const popupCount =
      $("#vm-cart-notif-count");

    if (popupCount) {
      popupCount.textContent =
        cart.item_count || 0;
    }

    /* ---------- Free-shipping progress bar ---------- */

    const drawerWrap =
      $("#nbCartDrawer");

    const shipBar =
      $("#nbDrawerShipBar");

    const shipMsg =
      $("#nbDrawerShipMsg");

    const shipFill =
      $("#nbDrawerShipFill");

    const pairedRail =
      $("#nbDrawerPaired");

    if (
      drawerWrap &&
      shipBar &&
      shipMsg &&
      shipFill
    ) {

      const thresholdCents =
        parseInt(
          drawerWrap.dataset.freeThresholdCents ||
          "140000",
          10
        );

      if (cart.item_count > 0) {

        const subtotal =
          cart.items_subtotal_price;

        const remaining =
          Math.max(
            0,
            thresholdCents - subtotal
          );

        const pct =
          Math.min(
            100,
            (subtotal / thresholdCents) * 100
          );

        shipBar.style.display = "";

        shipFill.style.width =
          pct + "%";

        if (remaining === 0) {

          shipBar.classList.add(
            "is-unlocked"
          );

          shipMsg.innerHTML = `
            <svg width="14" height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            <strong>
              You unlocked free delivery.
            </strong>
          `;

        } else {

          shipBar.classList.remove(
            "is-unlocked"
          );

          const remainingEGP =
            (remaining / 100).toLocaleString(
              "en-EG",
              {
                minimumFractionDigits: 0
              }
            );

          shipMsg.innerHTML = `
            <svg width="14" height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polygon
                points="3 11 22 2 13 21 11 13 3 11"
                fill="currentColor"/>
            </svg>

            Add
            <strong class="tnum">
              ${remainingEGP} EGP
            </strong>
            more to unlock
            <strong>
              free delivery
            </strong>.
          `;

        }

      } else {

        shipBar.style.display =
          "none";

      }

    }

    /* ---------- Paired rail ---------- */

    if (pairedRail) {

      pairedRail.style.display =
        cart.item_count > 0
          ? ""
          : "none";

    }

    if (!list) {
      return cart;
    }

    /* ---------- Empty cart ---------- */

    if (cart.item_count === 0) {

      list.innerHTML = "";

      if (empty) {
        empty.style.display = "";
      }

      if (foot) {
        foot.style.display = "none";
      }

      return cart;
    }

    if (empty) {
      empty.style.display = "none";
    }

    if (foot) {
      foot.style.display = "";
    }

    /* ---------- Group cart items ---------- */

    const bundles = {};
    const regulars = [];

    cart.items.forEach(it => {

      const boxId =
        it.properties?._box_id;

      if (boxId) {

        if (!bundles[boxId]) {

          bundles[boxId] = {
            id: boxId,
            size: parseInt(
              it.properties._box_size || "0",
              10
            ),
            discount: parseInt(
              it.properties._box_discount || "0",
              10
            ),
            items: [],
            total: 0,
            originalTotal: 0,
          };

        }

        bundles[boxId].items.push(it);

        bundles[boxId].total +=
          it.final_line_price;

        bundles[boxId].originalTotal +=
          it.original_line_price;

      } else {

        regulars.push(it);

      }

    });

    /* ---------- SVG icons ---------- */

    const trashSvg = `
      <svg width="18" height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round">

        <polyline points="3 6 5 6 21 6"/>

        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>

        <path d="M10 11v6"/>

        <path d="M14 11v6"/>

      </svg>
    `;

    const giftSvg = `
      <svg width="20" height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round">

        <polyline points="20 12 20 22 4 22 4 12"/>

        <rect
          x="2"
          y="7"
          width="20"
          height="5"/>

        <line
          x1="12"
          y1="22"
          x2="12"
          y2="7"/>

        <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>

        <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>

      </svg>
    `;

    /* ---------- Bundle HTML ---------- */

    const bundleHtml =
      Object.values(bundles)
        .map(b => {

          const totalQty =
            b.items.reduce(
              (s, i) => s + i.quantity,
              0
            );

          const boxCount =
            b.size > 0
              ? Math.max(
                  1,
                  Math.round(
                    totalQty / b.size
                  )
                )
              : 1;

          const picksHtml =
            b.items
              .map(i => `
                <li class="cart-bundle__pick">
                  <span class="cart-bundle__pick-name">
                    ${i.product_title}
                  </span>

                  <span class="cart-bundle__pick-qty tnum">
                    × ${i.quantity}
                  </span>
                </li>
              `)
              .join("");

          const picksStr =
            b.items
              .map(
                i =>
                  `${i.variant_id}:${i.quantity}`
              )
              .join(",");

          const editUrl =
            `/products/make-your-own-box-${b.size}?edit=${encodeURIComponent(b.id)}&picks=${encodeURIComponent(picksStr)}`;

          return `
            <div
              class="cart-bundle"
              data-bundle-id="${b.id}"
              data-bundle-size="${b.size}"
              data-bundle-count="${boxCount}">

              <div class="cart-bundle__head">

                <span class="cart-bundle__icon">
                  ${giftSvg}
                </span>

                <div class="cart-bundle__title-wrap">

                  <h3 class="cart-bundle__title">
                    Create Your Own Box of ${b.size}
                  </h3>

                  <p class="cart-bundle__tag">
                    Save ${b.discount}% on this bundle
                  </p>

                </div>

                <button
                  type="button"
                  class="cart-bundle__remove"
                  data-bundle-remove="${b.id}"
                  aria-label="Remove bundle">

                  ${trashSvg}

                </button>

              </div>

              <ul class="cart-bundle__picks">
                ${picksHtml}
              </ul>

              <div class="cart-bundle__foot">

                <div
                  class="cart-bundle__qty"
                  data-bundle-qty="${b.id}">

                  <button
                    type="button"
                    data-bundle-dec
                    aria-label="Fewer boxes">
                    −
                  </button>

                  <span data-bundle-count-out>
                    ${boxCount}
                  </span>

                  <button
                    type="button"
                    data-bundle-inc
                    aria-label="More boxes">
                    +
                  </button>

                </div>

                <div class="cart-bundle__prices">

                  ${
                    b.originalTotal !== b.total
                      ? `
                        <span class="cart-bundle__strike tnum">
                          ${formatMoney(b.originalTotal)}
                        </span>
                      `
                      : ""
                  }

                  <span class="cart-bundle__total tnum">
                    ${formatMoney(b.total)}
                  </span>

                </div>

              </div>

              <p class="cart-bundle__edit">
                <a href="${editUrl}">
                  Edit picks →
                </a>
              </p>

            </div>
          `;

        })
        .join("");

    /* ---------- Regular cart HTML ---------- */

    const regularHtml =
      regulars
        .map(it => `

          <div
            class="cart-line"
            data-key="${it.key}">

            <div class="cart-line__media">

              ${
                it.image
                  ? `
                    <img
                      src="${it.image}"
                      alt="${it.product_title}">
                  `
                  : ""
              }

            </div>

            <div>

              <h3 class="cart-line__title">
                ${it.product_title}
              </h3>

              <p class="cart-line__price tnum">
                ${formatMoney(it.final_price)}
              </p>

              <div class="cart-line__controls">

                <div
                  class="cart-line__qty"
                  data-qty
                  data-key="${it.key}">

                  <button
                    type="button"
                    data-line-dec
                    aria-label="Decrease">
                    −
                  </button>

                  <span data-line-qty>
                    ${it.quantity}
                  </span>

                  <button
                    type="button"
                    data-line-inc
                    aria-label="Increase">
                    +
                  </button>

                </div>

                <button
                  type="button"
                  class="cart-line__remove"
                  data-line-remove
                  aria-label="Remove">

                  ${trashSvg}

                </button>

              </div>

            </div>

          </div>

        `)
        .join("");

    list.innerHTML =
      bundleHtml + regularHtml;

    if (totalEl) {
      totalEl.textContent =
        formatMoney(
          cart.items_subtotal_price
        );
    }

    return cart;
  }

  /* ---------- Format money ---------- */

  function formatMoney(cents) {

    return `${(
      cents / 100
    ).toLocaleString(
      "en-EG",
      {
        minimumFractionDigits: 0
      }
    )} EGP`;

  }

  /* ---------- Initial badge sync ---------- */

  refreshCart();

  /* ============================================================
     SEARCH OVERLAY
     ============================================================ */

  const searchOv =
    $("#nbSearchOverlay");

  const openSearch = () => {

    searchOv?.classList.add(
      "is-open"
    );

    document.body.style.overflow =
      "hidden";

    setTimeout(() => {
      $("#nbSearchInput")?.focus();
    }, 50);

  };

  const closeSearch = () => {

    searchOv?.classList.remove(
      "is-open"
    );

    document.body.style.overflow =
      "";

  };

  $$("[data-search-open]").forEach(el => {

    el.addEventListener(
      "click",
      (e) => {

        e.preventDefault();

        openSearch();

      }
    );

  });

  $$("[data-search-close]").forEach(el => {

    el.addEventListener(
      "click",
      closeSearch
    );

  });

  const searchInput =
    $("#nbSearchInput");

  const searchResults =
    $("#nbSearchResults");

  let searchT;

  searchInput?.addEventListener(
    "input",
    () => {

      clearTimeout(searchT);

      const q =
        searchInput.value.trim();

      if (q.length < 2) {

        if (searchResults) {
          searchResults.innerHTML =
            "";
        }

        return;
      }

      searchT = setTimeout(
        async () => {

          const url =
            `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`;

          const r =
            await fetch(url, {
              headers: {
                "Accept":
                  "application/json"
              }
            });

          const d =
            await r.json();

          const items =
            d?.resources?.results?.products ||
            [];

          if (!searchResults) {
            return;
          }

          if (!items.length) {

            searchResults.innerHTML =
              `<p class="caption">Nothing matches "${q}" yet.</p>`;

            return;
          }

          searchResults.innerHTML =
            items
              .map(p => `

                <a href="${p.url}">

                  <img
                    src="${p.image || ""}"
                    alt="${p.title}">

                  <div>

                    <div
                      style="font-family: var(--font-display); font-size: 16px; color: var(--fg);">

                      ${p.title}

                    </div>

                    <div class="caption tnum">
                      ${p.price ?? ""}
                    </div>

                  </div>

                </a>

              `)
              .join("");

        },
        180
      );

    }
  );

  $$("[data-search-chip]").forEach(el => {

    el.addEventListener(
      "click",
      () => {

        if (!searchInput) {
          return;
        }

        searchInput.value =
          el.dataset.searchChip ||
          el.textContent.trim();

        searchInput.dispatchEvent(
          new Event("input")
        );

      }
    );

  });

  /* ============================================================
     BACK BUTTON
     ============================================================ */

  $$("[data-back]").forEach(el => {

    el.addEventListener(
      "click",
      (e) => {

        try {

          const ref =
            document.referrer;

          const sameOrigin =
            ref &&
            new URL(ref).origin ===
              window.location.origin;

          if (
            sameOrigin &&
            window.history.length > 1
          ) {

            e.preventDefault();

            window.history.back();

          }

        } catch (_) {

          /* fallback to anchor */

        }

      }
    );

  });

  /* ============================================================
     PDP VARIANT PICKER
     ============================================================ */

  const pdpVariantsEl =
    $("#nbPdpVariants");

  if (pdpVariantsEl) {

    let variants = [];

    try {

      variants =
        JSON.parse(
          pdpVariantsEl.textContent
        );

    } catch (e) {

      console.error(
        "variant JSON parse:",
        e
      );

    }

    const priceEl =
      $("#nbPdpPrice");

    const optionGroups =
      $$("[data-option-position]");

    /* ---------- Swipeable image gallery ---------- */

    const galleryEl =
      $("#nbPdpGallery");

    const dots =
      $$("#nbPdpDots .pdp__dot");

    const slides =
      galleryEl
        ? $$(".pdp__slide", galleryEl)
        : [];

    const setActiveDot = (i) => {

      dots.forEach((d, di) => {

        d.classList.toggle(
          "is-active",
          di === i
        );

      });

    };

    if (galleryEl) {

      galleryEl.addEventListener(
        "scroll",
        () => {

          setActiveDot(
            Math.round(
              galleryEl.scrollLeft /
              galleryEl.clientWidth
            )
          );

        },
        {
          passive: true
        }
      );

      dots.forEach((dot, i) => {

        dot.addEventListener(
          "click",
          () => {

            galleryEl.scrollLeft =
              i *
              galleryEl.clientWidth;

          }
        );

      });

    }

    const scrollToMedia = (mediaId) => {

      if (
        !galleryEl ||
        mediaId == null
      ) {
        return;
      }

      const idx =
        slides.findIndex(
          s =>
            String(
              s.dataset.mediaId
            ) === String(mediaId)
        );

      if (idx >= 0) {

        galleryEl.scrollLeft =
          idx *
          galleryEl.clientWidth;

      }

    };

    function getSelectedOptions() {

      const sel = [];

      optionGroups.forEach(
        group => {

          const pos =
            parseInt(
              group.dataset.optionPosition,
              10
            );

          const active =
            group.querySelector(
              ".pdp__option-pill.is-active"
            );

          if (active) {

            sel[pos - 1] =
              active.dataset.optionValue;

          }

        }
      );

      return sel;

    }

    function findVariant(selected) {

      return variants.find(v => {

        return (
          v.options || []
        ).every(
          (val, i) =>
            selected[i] === val
        );

      });

    }

    function updateForVariant(v) {

      if (!v) {
        return;
      }

      /* Sync variant ID */
      $$(".js-variant-id")
        .forEach(
          el =>
            el.value = v.id
        );

      const priceTxt =
        (
          v.price / 100
        ).toLocaleString(
          "en-EG",
          {
            minimumFractionDigits: 0
          }
        );

      const priceAmt =
        $("#nbPdpPriceAmount");

      if (priceAmt) {

        priceAmt.textContent =
          `${priceTxt} EGP`;

      } else if (priceEl) {

        priceEl.textContent =
          `${priceTxt} EGP`;

      }

      /* Compare-at price */

      const cmpEl =
        $("#nbPdpCompare");

      if (cmpEl) {

        if (
          v.compare_at_price &&
          v.compare_at_price > v.price
        ) {

          const cmpTxt =
            (
              v.compare_at_price / 100
            ).toLocaleString(
              "en-EG",
              {
                minimumFractionDigits: 0
              }
            );

          cmpEl.textContent =
            `${cmpTxt} EGP`;

          cmpEl.hidden = false;

        } else {

          cmpEl.textContent =
            "";

          cmpEl.hidden = true;

        }

      }

      /* Sync Add button price */

      $$(".js-price").forEach(
        el =>
          el.textContent =
            priceTxt
      );

      /* Gallery */

      if (
        v.featured_media &&
        v.featured_media.id != null
      ) {

        scrollToMedia(
          v.featured_media.id
        );

      }

    }

    $$(".pdp__option-pill")
      .forEach(pill => {

        pill.addEventListener(
          "click",
          () => {

            const pos =
              pill.dataset.optionPosition;

            $$(
              `[data-option-position="${pos}"].pdp__option-values .pdp__option-pill`
            )
              .forEach(b =>
                b.classList.remove(
                  "is-active"
                )
              );

            pill.classList.add(
              "is-active"
            );

            const v =
              findVariant(
                getSelectedOptions()
              );

            updateForVariant(v);

          }
        );

      });

    /* Initial variant */

    requestAnimationFrame(() => {

      const initialV =
        findVariant(
          getSelectedOptions()
        );

      if (
        initialV &&
        initialV.featured_media &&
        initialV.featured_media.id != null
      ) {

        scrollToMedia(
          initialV.featured_media.id
        );

      }

    });

  }

  /* ============================================================
     CYOB — CREATE YOUR OWN BOX
     ============================================================ */

  const cyobCounter =
    $("#cyobCounter");

  if (cyobCounter) {

    const maxPicks =
      parseInt(
        cyobCounter.dataset.cyobMax ||
        "6",
        10
      );

    const discountPct =
      parseInt(
        cyobCounter.dataset.cyobDiscountPct ||
        "0",
        10
      );

    const counterText =
      $("#cyobCounterText");

    const counterFill =
      $("#cyobCounterFill");

    const totalEl =
      $("#cyobTotal");

    const strikeEl =
      $("#cyobStrike");

    const savingsRow =
      $("#cyobSavings");

    const savingsAmt =
      $("#cyobSavingsAmt");

    const countSticky =
      $("#cyobCountSticky");

    const submitBtn =
      $("#cyobSubmit");

    const inlineBtn =
      $("#cyobInlineAdd");

    const boxQtyOut =
      $("[data-cyob-boxqty-out]");

    const boxQtyDec =
      $("[data-cyob-boxqty-dec]");

    const boxQtyInc =
      $("[data-cyob-boxqty-inc]");

    const cyobSticky =
      $("#cyobSticky");

    let boxQty = 1;

    const picks = {};

    function totalPicks() {

      return Object.values(picks)
        .reduce(
          (s, p) =>
            s + p.qty,
          0
        );

    }

    function rawSubtotalCents() {

      return Object.values(picks)
        .reduce(
          (s, p) =>
            s +
            p.priceCents *
            p.qty,
          0
        );

    }

    function discountedCents() {

      return Math.round(
        rawSubtotalCents() *
        (100 - discountPct) /
        100
      );

    }

    function fmt(cents) {

      return `${(
        cents / 100
      ).toLocaleString(
        "en-EG",
        {
          minimumFractionDigits: 0
        }
      )} EGP`;

    }

    function update() {

      const total =
        totalPicks();

      const pct =
        Math.min(
          100,
          (total / maxPicks) * 100
        );

      const raw =
        rawSubtotalCents();

      const disc =
        discountedCents();

      if (countSticky) {

        countSticky.textContent =
          total;

      }

      if (counterFill) {

        counterFill.style.width =
          pct + "%";

      }

      /* Pricing preview */

      if (totalEl) {

        if (total === 0) {

          totalEl.textContent =
            "—";

        } else {

          totalEl.textContent =
            fmt(disc);

        }

      }

      if (
        strikeEl &&
        total > 0 &&
        raw !== disc
      ) {

        strikeEl.hidden =
          false;

        strikeEl.textContent =
          fmt(raw);

      } else if (strikeEl) {

        strikeEl.hidden =
          true;

      }

      if (
        savingsRow &&
        savingsAmt
      ) {

        const saving =
          raw - disc;

        if (
          total > 0 &&
          saving > 0
        ) {

          savingsRow.hidden =
            false;

          savingsAmt.textContent =
            fmt(saving);

        } else {

          savingsRow.hidden =
            true;

        }

      }

      const remaining =
        maxPicks - total;

      const labelFull =
        "Add to bag";

      const labelPick =
        remaining === 1
          ? "Pick 1 more to add"
          : `Pick ${remaining} more to add`;

      if (total === maxPicks) {

        cyobCounter.classList.add(
          "is-full"
        );

        if (counterText) {

          counterText.textContent =
            "Your box is full — ready to add";

        }

        [submitBtn, inlineBtn]
          .forEach(btn => {

            if (!btn) {
              return;
            }

            btn.disabled = false;

            btn.textContent =
              labelFull;

          });

      } else {

        cyobCounter.classList.remove(
          "is-full"
        );

        if (counterText) {

          counterText.textContent =
            remaining === 1
              ? "Pick 1 more pastry"
              : `Pick ${remaining} more pastries`;

        }

        [submitBtn, inlineBtn]
          .forEach(btn => {

            if (!btn) {
              return;
            }

            btn.disabled = true;

            btn.textContent =
              labelPick;

          });

      }

      $$("[data-cyob-option]")
        .forEach(card => {

          const h =
            card.dataset.handle;

          const q =
            picks[h]?.qty || 0;

          const qtyEl =
            card.querySelector(
              "[data-cyob-qty]"
            );

          const decBtn =
            card.querySelector(
              "[data-cyob-dec]"
            );

          const incBtn =
            card.querySelector(
              "[data-cyob-inc]"
            );

          if (qtyEl) {

            qtyEl.textContent =
              q;

          }

          if (decBtn) {

            decBtn.disabled =
              q === 0;

          }

          if (incBtn) {

            incBtn.disabled =
              total >= maxPicks;

          }

          card.classList.toggle(
            "is-picked",
            q > 0
          );

        });

    }

    function add(card) {

      if (
        totalPicks() >= maxPicks
      ) {
        return;
      }

      const h =
        card.dataset.handle;

      if (!picks[h]) {

        picks[h] = {

          title:
            card.dataset.title,

          variantId:
            card.dataset.variantId,

          priceCents:
            parseInt(
              card.dataset.priceCents,
              10
            ),

          qty: 0,

        };

      }

      picks[h].qty += 1;

      update();

    }

    function remove(card) {

      const h =
        card.dataset.handle;

      if (
        !picks[h] ||
        picks[h].qty === 0
      ) {
        return;
      }

      picks[h].qty -= 1;

      if (
        picks[h].qty === 0
      ) {

        delete picks[h];

      }

      update();

    }

    $$("[data-cyob-option]")
      .forEach(card => {

        card
          .querySelector(
            "[data-cyob-inc]"
          )
          ?.addEventListener(
            "click",
            () => add(card)
          );

        card
          .querySelector(
            "[data-cyob-dec]"
          )
          ?.addEventListener(
            "click",
            () => remove(card)
          );

      });

    /* ---------- Box quantity ---------- */

    boxQtyDec?.addEventListener(
      "click",
      () => {

        if (boxQty > 1) {

          boxQty -= 1;

          if (boxQtyOut) {

            boxQtyOut.textContent =
              boxQty;

          }

          update();

        }

      }
    );

    boxQtyInc?.addEventListener(
      "click",
      () => {

        if (boxQty < 10) {

          boxQty += 1;

          if (boxQtyOut) {

            boxQtyOut.textContent =
              boxQty;

          }

          update();

        }

      }
    );

    /* ---------- Edit mode ---------- */

    const urlParams =
      new URLSearchParams(
        window.location.search
      );

    let editBoxId =
      urlParams.get("edit");

    const picksParam =
      urlParams.get("picks");

    if (picksParam) {

      picksParam
        .split(",")
        .forEach(pair => {

          const [
            vid,
            qtyStr
          ] =
            pair.split(":");

          const card =
            $$("[data-cyob-option]")
              .find(
                c =>
                  c.dataset.variantId ===
                  vid
              );

          if (!card) {
            return;
          }

          const n =
            parseInt(
              qtyStr,
              10
            ) || 0;

          for (
            let i = 0;
            i < n &&
            totalPicks() < maxPicks;
            i++
          ) {

            add(card);

          }

        });

    }

    async function submitBundle(btn) {

      if (
        totalPicks() !== maxPicks
      ) {
        return;
      }

      const items = [];

      /* One unique box_id per box */

      for (
        let b = 0;
        b < boxQty;
        b++
      ) {

        const boxId =
          `box-${Date.now().toString(36)}-${b}-${Math.random().toString(36).slice(2,7)}`;

        Object.values(picks)
          .forEach(p => {

            items.push({

              id:
                parseInt(
                  p.variantId,
                  10
                ),

              quantity:
                p.qty,

              properties: {

                _box_id:
                  boxId,

                _box_size:
                  String(maxPicks),

                _box_discount:
                  String(discountPct),

              },

            });

          });

      }

      const targets =
        [
          submitBtn,
          inlineBtn
        ].filter(Boolean);

      targets.forEach(t => {

        t.disabled = true;

        t.dataset.label =
          t.textContent;

        t.textContent =
          "🛒";

      });

      try {

        const res =
          await fetch(
            "/cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json"
              },
              body:
                JSON.stringify({
                  items
                }),
            }
          );

        if (!res.ok) {

          throw new Error(
            await res.text()
          );

        }

        /* EDIT MODE */

        if (editBoxId) {

          const cart =
            await (
              await fetch(
                "/cart.js"
              )
            ).json();

          const updates = {};

          cart.items.forEach(it => {

            if (
              it.properties?._box_id ===
              editBoxId
            ) {

              updates[it.key] =
                0;

            }

          });

          if (
            Object.keys(updates).length >
            0
          ) {

            await fetch(
              "/cart/update.js",
              {
                method: "POST",
                headers: {
                  "Content-Type":
                    "application/json",
                  "Accept":
                    "application/json"
                },
                body:
                  JSON.stringify({
                    updates
                  }),
              }
            );

          }

          editBoxId = null;

          window.history.replaceState(
            {},
            "",
            window.location.pathname
          );

        }

        await refreshCart();

        /* Reset picker */

        Object.keys(picks)
          .forEach(k =>
            delete picks[k]
          );

        boxQty = 1;

        if (boxQtyOut) {

          boxQtyOut.textContent =
            boxQty;

        }

        update();

        if (
          typeof openCart ===
          "function"
        ) {

          openCart();

        }

      } catch (err) {

        console.error(err);

        targets.forEach(t => {

          t.disabled = false;

          t.textContent =
            "Couldn't add — retry";

        });

        setTimeout(
          () => update(),
          1500
        );

      }

    }

    submitBtn?.addEventListener(
      "click",
      () =>
        submitBundle(submitBtn)
    );

    inlineBtn?.addEventListener(
      "click",
      () =>
        submitBundle(inlineBtn)
    );

    /* ---------- Hide sticky bar while inline button visible ---------- */

    if (
      cyobSticky &&
      inlineBtn
    ) {

      const io =
        new IntersectionObserver(
          ([entry]) => {

            cyobSticky.classList.toggle(
              "is-hidden",
              entry.isIntersecting
            );

          },
          {
            threshold: 0.1
          }
        );

      io.observe(inlineBtn);

    }

    update();

  }

  /* ============================================================
     STICKY BAR VISIBILITY ON PDP
     ============================================================ */

  const stickyBar =
    $("#nbPdpSticky");

  const inlineAdd =
    $("#nbPdpInlineAdd");

  if (
    stickyBar &&
    inlineAdd
  ) {

    const io =
      new IntersectionObserver(
        ([entry]) => {

          stickyBar.classList.toggle(
            "is-hidden",
            entry.isIntersecting
          );

        },
        {
          threshold: 0.1
        }
      );

    io.observe(inlineAdd);

  }

  /* ============================================================
     SHOP SCROLL-SPY CHIPS
     ============================================================ */

  const chipBar =
    $("[data-scrollspy]");

  if (chipBar) {

    const chips =
      $$(
        "[data-chip-anchor]",
        chipBar
      );

    const sections =
      $$("[data-chip-target]");

    const scroller =
      chipBar.querySelector(
        ".chips__inner"
      ) || chipBar;

    let prevActiveCat =
      null;

    const setActive = (cat) => {

      let activeChip = null;

      chips.forEach(c => {

        const isActive =
          c.dataset.chipAnchor ===
          cat;

        c.classList.toggle(
          "is-active",
          isActive
        );

        if (isActive) {
          activeChip = c;
        }

      });

      if (
        activeChip &&
        cat !== prevActiveCat
      ) {

        prevActiveCat = cat;

        const chipLeft =
          activeChip.offsetLeft;

        const chipRight =
          chipLeft +
          activeChip.offsetWidth;

        const visStart =
          scroller.scrollLeft;

        const visEnd =
          visStart +
          scroller.clientWidth;

        const pad = 24;

        if (
          chipRight > visEnd
        ) {

          scroller.scrollTo({
            left:
              chipRight -
              scroller.clientWidth +
              pad,
            behavior:
              "smooth"
          });

        } else if (
          chipLeft < visStart
        ) {

          scroller.scrollTo({
            left:
              Math.max(
                0,
                chipLeft - pad
              ),
            behavior:
              "smooth"
          });

        }

      }

    };

    /* ---------- Smooth scroll on chip tap ---------- */

    chips.forEach(chip => {

      chip.addEventListener(
        "click",
        (e) => {

          const cat =
            chip.dataset.chipAnchor;

          const target =
            document.getElementById(
              `cat-${cat}`
            );

          if (target) {

            e.preventDefault();

            const top =
              target.getBoundingClientRect()
                .top +
              window.scrollY -
              110;

            window.scrollTo({
              top,
              behavior:
                "smooth"
            });

            setActive(cat);

          }

        }
      );

    });

    /* ---------- Scroll spy ---------- */

    if (sections.length) {

      const THRESHOLD =
        130;

      const updateActive = () => {

        let activeIdx = 0;

        for (
          let i = 0;
          i < sections.length;
          i++
        ) {

          const top =
            sections[i]
              .getBoundingClientRect()
              .top;

          if (
            top <= THRESHOLD
          ) {

            activeIdx = i;

          } else {

            break;

          }

        }

        setActive(
          sections[activeIdx]
            .dataset.chipTarget
        );

      };

      let ticking = false;

      window.addEventListener(
        "scroll",
        () => {

          if (!ticking) {

            ticking = true;

            requestAnimationFrame(
              () => {

                updateActive();

                ticking = false;

              }
            );

          }

        },
        {
          passive: true
        }
      );

      updateActive();

    }

  }

})();